import translations from './const/pt.json';

const pt = {
  translation: {
    ...translations
  }
}

export default pt;